<template>
    <div class="body-wrapper">
        <div class="container-fluid">
            <div class="card card-body">
                <div class="row align-items-center">
                    <div class="col-12">
                        <div class="d-sm-flex align-items-center justify-space-between">
                            <h4 class="fw-semibold fs-4 mb-4 mb-md-0 card-title">Clientes</h4>
                            <nav aria-label="breadcrumb" class="ms-auto">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item" aria-current="page">
                                        <router-link to="/clientes/adicionar" type="submit" class="btn btn-primary btn-sm hstack gap-6">
                                        <i class="ti ti-plus fs-4"></i>
                                        Adicionar
                                        </router-link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card w-100 position-relative overflow-hidden">
                <div class="card-body p-4">
                    <table class="table text-nowrap mb-0 align-middle">
                        <thead class="text-dark fs-4">
                            <tr>
                                <th>
                                    <h6 class="fs-4 fw-semibold mb-0">Nome</h6>
                                </th>
                                <th>
                                    <h6 class="fs-4 fw-semibold mb-0">Telefone</h6>
                                </th>
                                <th>
                                    <h6 class="fs-4 fw-semibold mb-0">Data de Criação</h6>
                                </th>
                                <th>
                                    <h6 class="fs-4 fw-semibold mb-0">Status</h6>
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in list" :key="item.user_id">
                                <td>
                                    <div class="d-flex align-items-center">
                                        <img src="@/assets/images/profile/user-1.jpg" class="rounded-circle" width="40"
                                            height="40" />
                                        <div class="ms-3">
                                            <h6 class="fs-4 fw-semibold mb-0">{{item.name}}</h6>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <p class="mb-0 fw-normal">{{item.phone}}</p>
                                </td>
                                <td>
                                    <p class="mb-0 fw-normal">{{formatDate(item.created_at)}}</p>
                                </td>
                                <td>
                                    <span class="badge bg-success-subtle text-success" v-if="item.is_active == 1">Ativo</span>
                                    <span class="badge bg-danger-subtle text-danger" v-else>Inativo</span>
                                </td>
                                <td>
                                    <div class="dropdown dropstart">
                                        <a href="javascript:void(0)" class="text-muted" id="dropdownMenuButton"
                                            data-bs-toggle="dropdown" aria-expanded="false">
                                            <i class="ti ti-dots-vertical fs-6"></i>
                                        </a>
                                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <li>
                                                <span @click="pageEdit(item.user_id)" class="dropdown-item d-flex align-items-center gap-3" role="button">
                                                    <i class="fs-4 ti ti-edit"></i>Editar
                                                </span>
                                            </li>
                                            <li>
                                                <span class="dropdown-item d-flex align-items-center gap-3">
                                                    <i class="fs-4 ti ti-trash"></i>Excluir
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie';

export default {
    data() {
        return {
            role: 0,
            list: [],
            itemType: 2,
            addAddress: false,
        }
    },
    methods:{
        load(){
            this.$http.get('/list/user/' + this.itemType, {
                headers: {
                    'Authorization': 'Bearer ' + Cookies.get('_token')
                }
            }).then( response => {
                this.list = response.data.items
            })
        },
        formatDate(inputDate){
            const date = new Date(inputDate);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0')
            const formattedDate = `${day}/${month}/${year} às ${hours}:${minutes}`;
            return formattedDate;
        },
        pageEdit(id){
            this.$router.push('/clientes/editar/' + id)
        }
    },
    created(){
        this.role = this.$store.state.role;
    },
    mounted(){
        this.load()
        console.log(this.role)
    }
}
</script>